import { createTargetSelector } from '../../Redux/utils'

export const FETCH_GET = 'GET'
export const FETCH_POST = 'POST'
export const FETCH_PATCH = 'PATCH'
export const FETCH_PUT = 'PUT'
export const FETCH_DELETE = 'DELETE'

// Internal utilities

export const getResponseTarget = createTargetSelector('response')
export const getDataTarget = createTargetSelector('data')
export const getMetaTarget = createTargetSelector('meta')
export const getStatusTarget = createTargetSelector('status')
export const getErrorResponseTarget = createTargetSelector('errorResponse')
export const getErrorTarget = createTargetSelector('error')

// Client utilities

export const createFetchedTargetSelector = () => createTargetSelector('fetched')
export const createFetchedContentTargetSelector = () => createTargetSelector('content')
